<template>
    <input type="number"
           :name="input_name"
           v-model="price_model"
           @blur="hasBlur"
           class="form-control" required
           step="any"
           max="100000.00">

</template>

<script>
    import {integerToFloat} from "../../../../../../../resources/assets/js/helpers/money";

    export default {
        name: "BaseCurrencyInput",
        props: {
            value: null,
            input_name: {
                type: String,
                default: 'currency_input'
            }
        },
        data() {
            return {
                price_model: 0
            }
        },
        mounted() {
            if (this.value !== null) {
                this.price_model = (this.value < 1)? integerToFloat(this.value):this.makeCorrect(this.value);
            }
        },
        methods: {
            makeCorrect(value){
                return integerToFloat(value * 100)
            },
            hasBlur() {
                /**
                 * @param {Number} test
                 */
                let test = this.price_model.indexOf('.');
                if(test === -1)
                {
                    // console.log("Not Found . in str");
                    this.price_model = this.makeCorrect(this.price_model)
                }
            }
        }
    }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// app/Shared/Resources/Assets/js/components/base/BaseCurrencyInput.vue?3f2e790a